import MapWapper from './MapWapper';
import MapConfig from '@/api/mapmodule/model/MapConfig';
import SymbolConfig from '@/api/mapmodule/model/SymbolConfig';
/**
 * 地图全局共享变量
 */
export default class MapShare {
    private mapWapper: MapWapper;

    private mapConfig: MapConfig;

    private symbolConfig: SymbolConfig;

    public getMapWapper() {
        return this.mapWapper;
    }

    public setMapWapper(mapWapper: MapWapper) {
        this.mapWapper = mapWapper;
    }

    public getMapConfig() {
        return this.mapConfig;
    }

    public setMapConfig(mapConfig: MapConfig) {
        this.mapConfig = mapConfig;
    }

    public getSymbolConfig() {
        return this.symbolConfig;
    }

    public setSymbolConfig(symbolConfig: SymbolConfig) {
        this.symbolConfig = symbolConfig;
    }

}
